export default __webpack_public_path__ + "static/media/background.81228ea5.png";